import { createStyles } from 'antd-style';

export const useTrackSearchFormStyles = createStyles(({ token }) => ({
  trackNumberInput: {
    [`@media (min-width: ${token.screenMDMin}px)`]: {
      width: 240,
    },
    [`@media (max-width: ${token.screenSMMax}px)`]: {
      width: 200,
    },
  },
}));
